<template>
  <b-container id="gcash-details-page" v-if="isDataLoaded">
    <b-row>
      <b-col md="11" lg="8" class="mx-auto">
        <b-row>
          <b-col v-if="paymongoType === 'gcash'">
            <div id="gcash-logo">
              <img
                src="@/assets/images/gcash.png"
                class="img-fluid"
                alt="GCash"
              />
            </div>
            <span class="h4 ml-3 align-middle">GCash</span>
          </b-col>
          <b-col v-if="paymongoType === 'grabpay'">
            <div id="grabpay-logo" class="align-middle">
              <img
                src="@/assets/images/grabpay.png"
                class="img-fluid"
                alt="GrabPay"
              />
            </div>
            <span class="h4 ml-3 align-middle">GrabPay</span>
          </b-col>
        </b-row>
        <div class="border rounded px-0 pb-3 mt-5 bg-white">
          <b-row class="px-3 pt-3 pb-1">
            <b-col> Purchase Amount </b-col>
          </b-row>
          <b-row class="px-3">
            <b-col>
              <span class="h4"
                >&#8369; {{ orderDetails.computed_total | currency }}</span
              >
            </b-col>
            <b-col class="position-relative">
              <div v-b-toggle.collapse-purchase-details class="chevron-toggle">
                <img
                  src="@/assets/images/chevron-up.png"
                  alt="Chevron Up"
                  class="chevron-icon when-opened"
                />
                <img
                  src="@/assets/images/chevron-down.png"
                  alt="Chevron Down"
                  class="chevron-icon when-closed"
                />
              </div>
            </b-col>
          </b-row>
          <b-collapse
            id="collapse-purchase-details"
            class="border-top mt-2 pt-3"
          >
            <b-container>
              <b-row>
                <b-col cols="5"> Subtotal </b-col>
                <b-col cols="7" class="text-right font-weight-bold">
                  &#8369; {{ orderDetails.total | currency }}
                </b-col>
              </b-row>
              <b-row
                v-if="orderDetails.voucher_code && orderDetails.voucher_amount"
                class="mt-2"
              >
                <b-col cols="5">
                  Discount ({{ orderDetails.voucher_code }})</b-col
                >
                <b-col cols="7" class="text-right font-weight-bold">
                  - &#8369; {{ orderDetails.voucher_amount | currency }}
                </b-col>
              </b-row>
              <b-row class="mt-2" v-for="(fee, index) in fees" :key="index">
                <b-col cols="5">{{ fee.name }}</b-col>
                <b-col cols="7" class="text-right font-weight-bold">
                  &#8369; {{ fee.value | currency }}
                </b-col>
              </b-row>
              <hr />
              <b-row class="mt-2">
                <b-col> Total Payment </b-col>
                <b-col class="text-right font-weight-bold">
                  &#8369;
                  {{ orderDetails.computed_total | currency }}
                </b-col>
              </b-row>
            </b-container>
          </b-collapse>
        </div>
        <b-row class="my-4">
          <b-col>
            <span class="h4 font-weight-normal">Billing Details</span>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div>
              <div>
                <b-row>
                  <b-col lg="6">
                    <div class="floating-field-container">
                      <div class="floating-field">
                        <input
                          type="text"
                          v-model="form.firstName"
                          placeholder=" "
                        />
                        <label>First Name</label>
                      </div>
                    </div>
                    <b-form-invalid-feedback :state="validate('firstName')">
                      {{ displayError("firstName") }}
                    </b-form-invalid-feedback>
                  </b-col>
                  <b-col lg="6" class="mt-3 mt-lg-0">
                    <div class="floating-field-container">
                      <div class="floating-field">
                        <input
                          type="text"
                          v-model="form.lastName"
                          placeholder=" "
                        />
                        <label>Last Name</label>
                      </div>
                    </div>
                    <b-form-invalid-feedback :state="validate('lastName')">
                      {{ displayError("lastName") }}
                    </b-form-invalid-feedback>
                  </b-col>
                </b-row>
                <b-row class="mt-3">
                  <b-col>
                    <div class="floating-field-container">
                      <div class="floating-field">
                        <input
                          type="number"
                          v-model="form.mobileNumber"
                          placeholder=" "
                          data-maxlength="11"
                          oninput="this.value=this.value.slice(0,this.dataset.maxlength)"
                        />
                        <label>Contact Number</label>
                      </div>
                    </div>
                    <b-form-invalid-feedback :state="validate('mobileNumber')">
                      {{ displayError("mobileNumber") }}
                    </b-form-invalid-feedback>
                  </b-col>
                </b-row>
                <b-row class="mt-3">
                  <b-col>
                    <div class="floating-field-container">
                      <div class="floating-field">
                        <input
                          type="text"
                          v-model="form.email"
                          placeholder=" "
                        />
                        <label>Email Address </label>
                      </div>
                    </div>
                    <b-form-invalid-feedback :state="validate('email')">
                      {{ displayError("email") }}
                    </b-form-invalid-feedback>
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-col>
        </b-row>

        <b-row class="mt-5">
          <b-col class="text-center text-md-left">
            <b-link class="h6 text-secondary" :to="{ name: 'Checkout', params: { checkout_uuid: this.checkoutId } }">
              Cancel and return to website
            </b-link>
          </b-col>
          <b-col md="4" class="text-center text-md-left mt-3 mt-md-0">
            <b-button
              variant="primary"
              class="btn-core px-1 border-0"
              block
              :style="{
                backgroundColor: `${design.main_color} !important`,
                color: `${design.button_text_color} !important`
              }"
              @click="onNext"
            >
              Next
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import _ from "lodash";

export default {
  name: "PayMongoDetails",
  data() {
    return {
      isDataLoaded: false,
      orderId: null,
      checkoutId: null,
      form: {
        firstName: "",
        lastName: "",
        mobileNumber: "",
        email: ""
      }
    };
  },
  filters: {
    currency(value) {
      return new Intl.NumberFormat("en-US", {
        style: "decimal",
        minimumFractionDigits: 2
      }).format(Number.parseFloat(value).toFixed(2));
    }
  },
  computed: {
    ...mapState("merchant", ["customerPortalToken"]),
    ...mapState("estore", ["orderDetails"]),
    ...mapGetters("estore", ["design"]),
    ...mapGetters("customer", ["customerToken"]),
    fees() {
      if (!this.orderDetails) return [];

      const fees = _.flatten(this.orderDetails.orders.map(order => order.fees));

      return _(fees)
        .groupBy("name")
        .map(fee => ({
          ...fees[0],
          value: _.sumBy(fee, item => Number(item.value))
        }))
        .value();
    },
    paymongoType: {
      get() {
        return this.$route.params.paymongo_type;
      }
    }
  },
  methods: {
    validate(key) {
      if (this.errors && key in this.errors) return false;

      return null;
    },
    displayError(key) {
      if (this.errors && key in this.errors)
        return Array.isArray(this.errors[key])
          ? this.errors[key].join(" ")
          : this.errors[key];

      return "";
    },
    onNext() {
      const errors = {};
      this.$store.commit("customer/RESET_ERRORS");

      for (const field in this.form) {
        if (!this.form[field].trim()) errors[field] = "This field is required.";
      }

      if (this.form.mobileNumber && !/^09\d{9}$/.test(this.form.mobileNumber))
        errors.mobileNumber = "Please enter a valid contact number.";

      if (
        this.form.email &&
        !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/.test(this.form.email)
      )
        errors.email = "Please enter a valid email.";

      if (Object.keys(errors).length) {
        this.$store.commit("customer/SET_ERRORS", errors);

        return;
      }

      this.$router.push({
        name: "PayMongoPayment",
        params: { paymongo_type: this.$route.params.paymongo_type },
        query: {
          orderId: this.orderId,
          checkoutId: this.checkoutId,
          ...this.form
        }
      });
    },
    async getOrderDetails() {
      const request = {
        header: {
          "X-Merchant-Token": this.customerPortalToken
        },
        tracking_uuid: this.orderId
      };
      await this.$store.dispatch("estore/getOrderDetails", request);
    }
  },
  async created() {
    const { orderId, checkoutId } = this.$route.query;
    
    this.orderId = orderId;
    this.checkoutId = checkoutId;

    if (!orderId) this.$router.push({ name: "404" });

    await this.getOrderDetails();

    this.isDataLoaded = true;
  }
};
</script>

<style lang="scss">
@import "@/assets/styles/views/checkout/_gcash-details.scss";
</style>
